export default "__VITE_ASSET__CjtLZW$y__"